import { render } from "./achievements.vue?vue&type=template&id=c9342dc0&scoped=true"
import script from "./achievements.vue?vue&type=script&lang=js"
export * from "./achievements.vue?vue&type=script&lang=js"

import "./achievements.vue?vue&type=style&index=0&id=c9342dc0&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9342dc0"]])

export default __exports__